/* eslint-disable no-undef, no-unused-expressions */

typeof window.URLSearchParams === 'undefined'
  ? require('url-search-params-polyfill')
  : '';

typeof window.IntersectionObserver === 'undefined'
  ? require('intersection-observer')
  : '';

typeof Promise === 'undefined' || Promise.prototype.finally === undefined
  ? require('promise-polyfill/src/polyfill')
  : '';

typeof window.AbortController === 'undefined'
  ? require('abortcontroller-polyfill')
  : '';

'options' in document.createElement('datalist')
  ? ''
  : require('datalist-polyfill');

'open' in document.createElement('details')
  ? ''
  : require('details-polyfill');

'flat' in Array.prototype
  ? ''
  : require('array-flat-polyfill');
